import { Checkbox } from "@mantine/core";

import { FormCheckboxSectionListProps } from "../interfaces/form-components";

export function FormCheckboxSectionList({ items, onItemChange }: FormCheckboxSectionListProps) {
  return (
    <>
      {items.map(({ key, label, checked, disabled }, index) => (
        <Checkbox
          key={key}
          label={label}
          disabled={disabled}
          checked={checked && !disabled}
          onChange={(event) => onItemChange(index, event.currentTarget.checked)}
        />
      ))}
    </>
  );
}
